import reddot from '../reddot/reddot.vue.component';

export default {
  template: '#vsp-button-template',

  props: {
    syan: {
      type: Number,
      required: true,
    },
    colorId: {
      type: String,
      required: false,
    },
  },

  components: {
    reddot,
  },

  methods: {
    getVspPayload() {
      return {
        syan: this.syan,
        ...(this.colorId ? { farbId: this.colorId } : {}),
        listName: 'pds_icon',
      };
    },

    triggerVsp() {
      const vspPayload = this.getVspPayload();
      document.dispatchEvent(new CustomEvent('suchen:vsp:alternativeprodukte', { detail: vspPayload }));
      console.info('Visuell ähnliche Produkte werden angezeigt:', vspPayload);
      this.$el.setAttribute('data-test-ents-vsp-button-payload-emitted', JSON.stringify(vspPayload));
      this.$bus.$emit('reddot:read', 'vsp');
    },
  },
};
